import * as React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';

import MenuContent from './MenuContent';
import { useAuth } from '../../components/AuthContext';
import { useInstitution } from '../../components/InstitutionContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function SideMenuMobile({ open, toggleDrawer }) {
  const { user, logout } = useAuth();
  const { setSelectedInstitution } = useInstitution();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    setSelectedInstitution('');
    await logout();
    toggleDrawer(false)();
    navigate('/');
  };
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Stack
        sx={{
          maxWidth: '70dvw',
          height: '100%',
        }}
      >
        <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
          {user ? (
            <Stack sx={{ flexGrow: 1, p: 1, gap: 0.5 }}>
              <Stack direction="row" sx={{ gap: 1, alignItems: 'center' }}>
                <Avatar
                  alt={user.username || 'Guest User'}
                  src={user.avatar || '/static/images/avatar/placeholder.jpg'}
                  sx={{ width: 24, height: 24 }}
                />
                <Typography component="p" variant="h6">
                  {user.username}
                </Typography>
              </Stack>
            </Stack>
          ) : (
            <Stack direction="row" gap={1} sx={{ flexGrow: 1, p: 1, justifyContent: 'center' }}>
              <Button
                component={Link}
                to="/sign-in"
                state={{ from: location.pathname }}
                variant="outlined"
                size="small"
              >
                Log In
              </Button>
              <Button component={Link} to="/sign-up" variant="contained" size="small">
                Sign Up
              </Button>
            </Stack>
          )}
        </Stack>
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent />
        </Stack>
        {user && (
          <Stack sx={{ p: 2 }}>
            <Button variant="outlined" fullWidth startIcon={<LogoutRoundedIcon />} onClick={handleLogout}>
              Logout
            </Button>
          </Stack>
        )}
      </Stack>
    </Drawer>
  );
}

SideMenuMobile.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
};

export default SideMenuMobile;
